module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5n1r2r-d11e983d1f6e7d415a143309cb342a99.svg";